import React from "react";

import styled from "styled-components/macro";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";

import Button from "../Sections/Button";
import Card from "../Sections/Card";
import Description from "../Sections/Description";
import Icon from "../Sections/Icon";
import ProgressBar from "../Sections/ProgressBar";
import Subtitle from "../Sections/Subtitle";
import Title from "../Sections/Title";

const Generic = () => {
  const {
    customizations: { subTitlePosition = "bottom" } = {},
    ID,
    title,
  } = useCategoryCardContext();

  return (
    <Card key={ID}>
      {title && (
        <Header>
          <Titles>
            {subTitlePosition === "top" && <Subtitle />}
            <Title />
            {subTitlePosition === "bottom" && <Subtitle />}
          </Titles>
          <Icon />
        </Header>
      )}
      <Description />
      <Bottom>
        <ProgressBar />
        <ButtonWrapper>
          <Button />
        </ButtonWrapper>
      </Bottom>
    </Card>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
`;

const Bottom = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
const ButtonWrapper = styled.div`
  margin-top: 0.5rem;
`;
export default Generic;
